import React from 'react';

import Image from '../../../image/Image';
import { DropdownWrapper } from '../../../ui/dropdownwrapper/DropdownWrapper';
import Iconify from '../../../../layouts/components/iconify/iconify';

import { AppIcons } from '../../../../data/appIcons';

const getPriorityClass = (priority) => (
    priority?.label ? `is-${priority.label.toLowerCase().split(" ").join("")}` : "is-none"
);

const PrioritySelect = ({ priorityList, onChange, selectedPriority }) => {

    const defaultPriority = priorityList.length && selectedPriority ? priorityList.find(option => option.value === selectedPriority) : null;
    const priorityLabel = defaultPriority?.label || "Select Priority";

    return (
        <DropdownWrapper
            closeOnSelect={true}
            matchToggleWidth={true}
            className="taskgrid-chip-menu-popup"
            toggleElement={
                <div
                    className={`taskgrid-priority-dropdown is-editable ${getPriorityClass(defaultPriority)}`}
                    title={priorityLabel}
                >
                    <Image
                        imgCustomClassName="taskgrid-priority-icon"
                        imagePath={defaultPriority?.imagePath || AppIcons.plusIcon}
                        altText={`${priorityLabel} Priority`}
                    />
                    <span className="taskgrid-priority-type">{priorityLabel}</span>
                    <Iconify icon="bitcoin-icons:caret-down-filled" width={12} />
                </div>
            }
        >
            <div className="taskgrid-chip-menu">
                {priorityList?.length && priorityList.map((priority) => (
                    <button
                        type="button"
                        key={priority.value}
                        className="taskgrid-chip-menu-item"
                        onClick={() => onChange(priority)}
                    >
                        <span className={`taskgrid-priority-dropdown ${getPriorityClass(priority)}`}>
                            <Image
                                imgCustomClassName="taskgrid-priority-icon"
                                imagePath={priority.imagePath}
                                altText={`${priority.label}`}
                            />
                            <span className="taskgrid-priority-type">{priority.label}</span>
                        </span>
                    </button>
                ))}
            </div>
        </DropdownWrapper>
    )
}

export default PrioritySelect
